"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var User = __importStar(require("../../Actions/User"));
var CountdownTimer_1 = __importDefault(require("../../Components/CountdownTimer"));
var Google_1 = require("@styled-icons/boxicons-logos/Google");
var FacebookCircle_1 = require("@styled-icons/boxicons-logos/FacebookCircle");
var Line_1 = require("@styled-icons/fa-brands/Line");
var UserAgentUtil = __importStar(require("../../Utils/UserAgentUtil"));
var query_string_1 = __importDefault(require("query-string"));
function RequestPage(props) {
  var _this = this;
  var _a = props.pageContext,
    _b = _a === void 0 ? {} : _a,
    _c = _b.pageId,
    pageId = _c === void 0 ? 'rev-RegisterRequestPage' : _c,
    _d = props.canFacebookLogin,
    canFacebookLogin = _d === void 0 ? false : _d,
    _e = props.canGoogleLogin,
    canGoogleLogin = _e === void 0 ? false : _e,
    _f = props.canLineLogin,
    canLineLogin = _f === void 0 ? false : _f;
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var _g = react_1.default.useState(null),
    requestResult = _g[0],
    setRequestResult = _g[1];
  var _h = react_1.default.useState(0),
    endTime = _h[0],
    setEndTime = _h[1];
  var params = query_string_1.default.parse(props.location.search);
  var onFinish = function onFinish(values) {
    return __awaiter(_this, void 0, void 0, function () {
      var username, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            username = values.username;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            actions.setLoading(true);
            return [4 /*yield*/, User.registerRequest(username.trim(), {
              refer_by: params.refer_by
            })];
          case 2:
            _a.sent();
            setEndTime(new Date().getTime() + 2 * 60 * 1000);
            setRequestResult(true);
            return [3 /*break*/, 5];
          case 3:
            ex_1 = _a.sent();
            console.log('EX', ex_1);
            setRequestResult(false);
            return [3 /*break*/, 5];
          case 4:
            actions.setLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };

  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };
  var disableInput = requestResult === true;
  var onSocialLogin = function onSocialLogin(type) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        try {
          if (type === 'google') {
            User.googleRedirect(params.refer_by);
          } else if (type === 'facebook') {
            User.facebookRedirect(params.refer_by);
          } else if (type === 'line') {
            User.lineRedirect(params.refer_by);
          }
        } catch (err) {
          console.warn('RegisterRequestPage.onSocialLogin err', err);
        }
        return [2 /*return*/];
      });
    });
  };

  return react_1.default.createElement(Wrapper, {
    id: pageId
  }, react_1.default.createElement("div", {
    className: "content"
  }, react_1.default.createElement("h2", {
    style: {
      marginBottom: 10
    }
  }, "\u8A3B\u518A\u65B0\u5E33\u865F"), requestResult === true && react_1.default.createElement("div", {
    className: "success",
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u6210\u529F"), react_1.default.createElement("p", null, "\u8ACB\u5230\u60A8\u7533\u8ACB\u7684\u4FE1\u7BB1\u9EDE\u64CA\u8A8D\u8B49\u9023\u7D50, \u5B8C\u6210\u8A3B\u518A\u6D41\u7A0B!")), requestResult === false && react_1.default.createElement("div", {
    className: "failure",
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u5931\u6557"), react_1.default.createElement("p", null, "\u8A3B\u518A\u8ACB\u6C42\u5931\u6557, \u8ACB\u91CD\u65B0\u5617\u8A66\u4E00\u6B21")), react_1.default.createElement(antd_1.Form, {
    layout: "vertical",
    name: "register",
    onFinish: onFinish,
    onFinishFailed: onFinishFailed
  }, react_1.default.createElement(antd_1.Form.Item, {
    label: "EMAIL",
    name: "username",
    rules: [{
      required: true,
      message: '請輸入EMAIL!'
    }]
  }, react_1.default.createElement(antd_1.Input, {
    disabled: disableInput
  })), react_1.default.createElement(CountdownTimer_1.default, {
    endTimeMs: endTime,
    renderText: function renderText(secRemaining) {
      return "\u8ACB\u65BC " + secRemaining + " \u79D2\u5167\u5B8C\u6210\u8A8D\u8B49";
    },
    style: {
      textAlign: 'right'
    }
  }, react_1.default.createElement(antd_1.Form.Item, {
    style: {
      textAlign: 'right'
    }
  }, react_1.default.createElement(antd_1.Button, {
    type: "primary",
    htmlType: "submit"
  }, requestResult === true ? '重傳認證信' : '註冊')))), (canFacebookLogin || canGoogleLogin || canLineLogin) && react_1.default.createElement("section", {
    className: "social"
  }, react_1.default.createElement("div", {
    className: "title"
  }, react_1.default.createElement("h3", null, "\u6216\u4F7F\u7528\u4E0B\u5217\u65B9\u5F0F")), react_1.default.createElement("div", {
    className: "buttons"
  }, canGoogleLogin && !UserAgentUtil.isInFacebook() && react_1.default.createElement("button", {
    onClick: function onClick() {
      return onSocialLogin('google');
    }
  }, react_1.default.createElement(Google_1.Google, {
    size: 40,
    color: '#ea4335'
  })), canFacebookLogin && react_1.default.createElement("button", {
    onClick: function onClick() {
      return onSocialLogin('facebook');
    }
  }, react_1.default.createElement(FacebookCircle_1.FacebookCircle, {
    size: 40,
    color: '#1877f2'
  })), canLineLogin && react_1.default.createElement("button", {
    onClick: function onClick() {
      return onSocialLogin('line');
    }
  }, react_1.default.createElement(Line_1.Line, {
    size: 40,
    color: '#02C755'
  }))))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n\n    & > section.social {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      & > .title {\n        align-self: stretch;\n        display: flex;\n        align-items: center;\n        margin: 40px 0 10px;\n\n        & h3 {\n          margin: 0px 10px;\n        }\n\n        &::before,\n        &::after {\n          content: '';\n          flex: 1;\n          height: 1px;\n          background-color: #ccc;\n        }\n      }\n\n      & > .buttons {\n        dipslay: flex;\n\n        & > * {\n          border: none;\n          background-color: transparent;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"], ["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n\n    & > section.social {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      & > .title {\n        align-self: stretch;\n        display: flex;\n        align-items: center;\n        margin: 40px 0 10px;\n\n        & h3 {\n          margin: 0px 10px;\n        }\n\n        &::before,\n        &::after {\n          content: '';\n          flex: 1;\n          height: 1px;\n          background-color: #ccc;\n        }\n      }\n\n      & > .buttons {\n        dipslay: flex;\n\n        & > * {\n          border: none;\n          background-color: transparent;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"])));
exports.default = RequestPage;
var templateObject_1;